import api from '@/lib/hippo'
import Vue from 'vue'
import SurveyLink from '@/models/survey_link'
import Result from '@/models/result'
import ResultEntry from '@/models/result_entry';
import { mapDebugActions } from '@/lib/debug';

function initialState() {
	return {
		surveys: {},
		completed: {},
		survey_result: {}
	};
}

const state = initialState;

const getters = {};

const actions = {
	fetchSurveys ({commit, rootGetters}, enrol_id) {
		return new Promise((resolve, reject) => {
			if (rootGetters.apiToken && enrol_id) {
				api.getSurveys(rootGetters.apiToken, enrol_id)
				.then( (response) => {
					commit ('setSurveys', SurveyLink.from(response.data) );
					resolve(true);
				}).catch( (err) => reject(err) );
			} else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );;
		});
	},

	fetchSurveyResult ({commit, rootGetters}, {enrol_id, surveylink_id, task_id}) {
		return new Promise((resolve, reject) => {
			mapDebugActions.debugObject ({enrol_id, surveylink_id, task_id}, 'survey.js >> fetchSurveyResult')
			if (rootGetters.apiToken && enrol_id && (surveylink_id != null || task_id != null)) {
				api.fetchSurveyResult(rootGetters.apiToken, enrol_id, surveylink_id, task_id)
				.then( (response) => {
					let result = Result.from(response.data)
					commit ('setSurveyResult', result );
					resolve(result);
				}).catch( (err) => reject(err) );
			} else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );;
		});
	},

	submitResultEntry({commit, rootGetters}, {enrol_id, surveylink_id, task_id, result_id, data}) {
		//mapDebugActions.debugObject ({enrol_id, surveylink_id, task_id, result_id, result_entry}, 'survey.js >> submitResultEntry')
		return new Promise((resolve, reject) => {
			if (rootGetters.apiToken && enrol_id && (surveylink_id || task_id) && result_id && data) {
				api.updateSurveyResultEntry(rootGetters.apiToken, enrol_id, surveylink_id, task_id, result_id, data)
					.then( (response) => {
						let result_entry = ResultEntry.from(response.data)
						if (Array.isArray(response.data.data)) {
							for (const key of Object.keys(result_entry)) {
								commit('setResultEntry', result_entry[key] );
							}
						} else {
							commit ('setResultEntry', result_entry );
						}
						resolve(result_entry);
				}).catch( (err) => reject(err) );
			} else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );;
		});
	},
	completeSurvey ({state, rootGetters}, {enrol_id, surveylink_id, task_id, data = {}} ){
		return new Promise((resolve, reject) => {
			if (rootGetters.apiToken && enrol_id && (surveylink_id || task_id)) {
				api.completeSurveyResult(rootGetters.apiToken, enrol_id, surveylink_id, task_id, state.survey_result.id, data)
				.then( (response) => {
					resolve(true);
				}).catch( (err) => reject(err) );
			} else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );;
		});
	},
	fetchCompleteSurveys ({commit, rootGetters}, enrol_id) {
		return new Promise((resolve, reject) => {
			if (rootGetters.apiToken && enrol_id) {
				api.getSurveys(rootGetters.apiToken, enrol_id, true)
				.then( (response) => {
					commit ('setCompleteSurveys', SurveyLink.from(response.data) );
					resolve(true);
				}).catch( (err) => reject(err) );
			} else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );;
		});
	},
	resetSurveysState ({commit}) {
		commit('resetState');
	}
};

const mutations = {
	setSurveys: (state, surveys) => {
		Vue.set(state, 'surveys', surveys);
	},

	setSurveyResult: (state, survey_result) => {
		Vue.set(state, 'survey_result', survey_result);
	},

	setResultEntry: (state, result_entry) => {
		Vue.set(state.survey_result.result_entries, result_entry.id, result_entry);
	},

	setCompleteSurveys: (state, surveys) => {
		Vue.set(state, 'completed', surveys);
	},

	resetState ( state ) {
		const s = initialState();
		Object.keys(s).forEach(key => {
			Vue.set(state, key, s[key]);
		});
	}
};

export default {
	state,
	getters,
	actions,
	mutations
}
